/**
 * ============================================================================
 * [P3-02-E] BarChart - 바 차트 컴포넌트
 *
 * Chart.js를 사용한 바 차트
 * - 요일별/시간대별 분포 시각화
 * ============================================================================
 */

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import styles from './Tracking.module.css'

// ============================================================================
// [P3-02-E] Chart.js 등록
// ============================================================================
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip
)

// ============================================================================
// Types
// ============================================================================
interface BarChartProps {
  data: {
    labels: string[]
    values: number[]
  }
  title: string
}

// ============================================================================
// [P3-02-E] BarChart Component
// ============================================================================
export function BarChart({ data, title }: BarChartProps) {
  // ========================================================================
  // 차트 데이터 구성
  // ========================================================================
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: title,
        data: data.values,
        backgroundColor: 'rgba(102, 126, 234, 0.7)',
        borderRadius: 4,
      },
    ],
  }

  // ========================================================================
  // 차트 옵션
  // ========================================================================
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: title,
        font: { size: 14, weight: 'bold' as const },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { stepSize: 1 },
      },
    },
  }

  // ========================================================================
  // Render
  // ========================================================================
  return (
    <div className={styles.chartWrapper}>
      <Bar data={chartData} options={options} />
    </div>
  )
}

export default BarChart
